import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { FrameworkContract, FrameworkContractsService } from '../../../core/api';
import { Store } from '@ngrx/store';
import { addFrameworkContract } from '../../../core/states/offer/offer.actions';
import { catchError, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FrameworkContractState } from '../../../core/states/offer/offer.state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const mapToFrameworkContractState = (frameworkContract: FrameworkContract): FrameworkContractState => {
  return {
    number: frameworkContract.number,
    name: frameworkContract.name,
    syriusKey: {
      contractNumber: frameworkContract.syrius_key.contract_number,
      personGroupShortDescription: frameworkContract.syrius_key.person_group_short_description,
    },
  };
};

export const frameworkContractsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): UrlTree | Observable<UrlTree | boolean> => {
  const router: Router = inject(Router);
  const frameworkContractsService: FrameworkContractsService = inject(FrameworkContractsService);
  const store: Store = inject(Store);

  const frameworkContractNumber = route.queryParamMap.get('frameworkContractNumber');

  if (!frameworkContractNumber) {
    return of(true);
  }
  const saveFrameworkContractToStore = (frameworkContract: FrameworkContract): void => {
    store.dispatch(addFrameworkContract(mapToFrameworkContractState(frameworkContract)));
  };
  return frameworkContractsService.findFrameworkContract(frameworkContractNumber).pipe(
    takeUntilDestroyed(),
    tap(saveFrameworkContractToStore),
    map(() => true),
    catchError(() => of(router.parseUrl('/framework-contracts-error'))),
  );
};
